module.exports = __webpack_public_path__ + "img/icon-nav5.1c92df66.svg";